module.exports = __webpack_public_path__ + "static/frsteve-a0593394b3d14997692de9f36e25915e.jpg";